import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["renderImmediately"];
import { useCallback, useEffect, useRef, useState } from 'react';
import { delayUntilIdle } from '../crm_ui/utils/delayUntilIdle';

/**
 * Number of milliseconds to wait for fallback call.
 */
import { jsx as _jsx } from "react/jsx-runtime";
const FALLBACK_CALL_TIMEOUT = 8000;
const rhumbResolutionMarkers = ['mark_all_success', 'mark_all_failure', 'mark_all_failure_watchdog_expired'];
export const withDelayUntilIdleAndPerfResolved = WrappedComponent => {
  // preserve the rendered state between re-mounts
  // we don't want to delay the component if it has already been mounted
  let rendered = false;
  const DelayedComponent = _ref => {
    let {
        renderImmediately = false
      } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded);
    const [shouldRender, setShouldRender] = useState(rendered);
    const fallbackTimeoutRef = useRef(undefined);
    const render = () => {
      setShouldRender(true);
      rendered = true;
    };
    const perfObserver = useCallback(list => {
      for (const entry of list.getEntries()) {
        if (entry.entryType === 'mark' && rhumbResolutionMarkers.includes(entry.name)) {
          delayUntilIdle(() => render());
          clearTimeout(fallbackTimeoutRef.current);
        }
      }
    }, []);
    useEffect(() => {
      if (rendered) {
        return;
      }
      if (window.PerformanceObserver) {
        const observer = new PerformanceObserver(perfObserver);
        observer.observe({
          type: 'mark',
          buffered: true
        });
        fallbackTimeoutRef.current = setTimeout(() => {
          render();
        }, FALLBACK_CALL_TIMEOUT);
      } else {
        delayUntilIdle(() => render());
      }
    }, [perfObserver]);
    if (shouldRender || renderImmediately) {
      return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, rest));
    }
    return null;
  };
  return DelayedComponent;
};